import React from 'react';
import useUploadQueue from '../../hooks/useUploadQueue';
import useMutationQueue from '../../hooks/useMutationQueue';

/**
 * Indicador de estado de conexion, cola de uploads y mutaciones offline
 *
 * Se muestra fixed en la esquina inferior derecha.
 * Solo visible cuando hay informacion relevante (offline, pendientes, subiendo).
 *
 * @returns {JSX.Element|null}
 */
function ConnectionStatus() {
  const { isOnline, isProcessing: uploadProcessing, pendingCount: uploadPending } = useUploadQueue();
  const { isProcessing: mutationProcessing, pendingCount: mutationPending } = useMutationQueue();

  const totalPending = uploadPending + mutationPending;
  const anyProcessing = uploadProcessing || mutationProcessing;

  // No mostrar si todo esta bien
  if (isOnline && totalPending === 0 && !anyProcessing) {
    return null;
  }

  return (
    <div className="connection-status">
      {!isOnline && (
        <div className="connection-status-badge connection-status-offline">
          <i className="fas fa-wifi-slash"></i>
          <span>Sin conexion</span>
        </div>
      )}
      {anyProcessing && (
        <div className="connection-status-badge connection-status-uploading">
          <i className="fas fa-spinner fa-spin"></i>
          <span>Sincronizando...</span>
        </div>
      )}
      {totalPending > 0 && !anyProcessing && (
        <div className="connection-status-badge connection-status-pending">
          <i className="fas fa-cloud-upload-alt"></i>
          <span>{totalPending} pendiente{totalPending > 1 ? 's' : ''}</span>
        </div>
      )}
    </div>
  );
}

export default ConnectionStatus;
